import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function createZone(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_zone = userData;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_ZONE_REQUESTED", "CREATE_ZONE_SUCCESS", "CREATE_ZONE_FAILED"],
        method: "POST",
        path: "admin/create_zone",
        body: data
    });
}

export function getZones() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_ZONES_REQUESTED", "GET_ZONES_SUCCESS", "GET_ZONES_FAILED"],
        method: "POST",
        path: "admin/get_zones",
        body: data
    });
}

export function updateZone(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_zone = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_ZONE_REQUESTED", "UPDATE_ZONE_SUCCESS", "UPDATE_ZONE_FAILED"],
        method: "POST",
        path: "admin/update_zone",
        body: data
    });
}

export function deleteZone(zoneId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_zone = {"zone_id": zoneId};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_ZONE_REQUESTED", "DELETE_ZONE_SUCCESS", "DELETE_ZONE_FAILED"],
        method: "POST",
        path: "admin/delete_zone",
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionZones.js